/**
 * ADD RSS FEED - FEED INFORMATION TEMPLATE
 *
 *
 * @version 0.1
 */

import React from 'react';
import ReactDOM from 'react-dom';
import { FormattedMessage } from 'react-intl';
import reduxStore from './../../../../reduxStore';
import actions from './../BaseFeedEditingComponent.actions.js';
import utils from './../../../../utils/utilities';

import { ADD_RSS_INPUT_CHAR_LIMIT } from './../../../../constants';

class FeedInformation extends React.Component {

    constructor(props) {
        super(props);
        this.state = Object.assign(
            {
                feedNameInputValue: '',
                characterCount:     ADD_RSS_INPUT_CHAR_LIMIT
            },
            reduxStore.getState().addRssFeed.feedInformation
        );

        this.maxFeedNameLength = ADD_RSS_INPUT_CHAR_LIMIT;
        this.clearValidIndicator = true;

        this.changeFeedNameHandler = this.changeFeedNameHandler.bind(this);
        this.validateInputField = this.validateInputField.bind(this);
        this.resetValidationIndicators = this.resetValidationIndicators.bind(this);
        this.setValidClass = this.setValidClass.bind(this);
    }

    componentWillMount() {
        this.unsubscribe = reduxStore.subscribe(
            () => {
                this.setState(reduxStore.getState().addRssFeed.feedInformation);
            }
        );
    }

    componentDidMount() {
        this.rootNode = ReactDOM.findDOMNode(this);
    }

    componentWillUpdate(nextProps, nextState) {

        if (nextState.feedName !== this.state.feedName) {
            this.setState({
                feedNameInputValue: nextState.feedName,
                characterCount:     this.maxFeedNameLength - nextState.feedName.length
            });
        }

    }

    componentWillUnmount() {
        this.unsubscribe();
    }

    changeFeedNameHandler(event) {
        let inputValue   = event.target.value,
            inputCounter = inputValue.length;

        this.setState({
            feedNameInputValue: inputValue,
            characterCount:     this.maxFeedNameLength - inputCounter
        });
        this.resetValidationIndicators(inputValue.trim().length);
    }

    validateInputField(event) {
        let feedNameInput = event.target,
            feedName      = feedNameInput.value.trim();

        // Capitalize first letter in user input
        feedName = feedName.charAt(0).toUpperCase() + feedName.slice(1);

        // Set input value to user input with capitalized first character and update counter
        this.setState({
            feedNameInputValue: feedName,
            characterCount:     this.maxFeedNameLength - feedName.length
        });

        // Validate user input data
        this.clearValidIndicator = false;
        if (feedName.length > 0) {
            actions.validateNameField(feedName, this.props.feedId);
            actions.toggleFeedNameValidation(true);
        } else {
            this.clearValidIndicator = true;
            actions.toggleFeedNameValidation(false);
        }
    }

    resetValidationIndicators(inputLength) {
        this.clearValidIndicator = true;
        actions.toggleFeedNameValidation(inputLength > 0 ? true : false);
        actions.clearValidationErrors(['api.error.feed.missingTitle', 'api.error.feed.duplicateTitle']);
    }

    setValidClass() {
        let saveErrors    = reduxStore.getState().addRssFeed.saveErrors,
            checkedErrors = ['api.error.feed.missingTitle', 'api.error.feed.duplicateTitle'];

        if (utils.arrayDiff(checkedErrors, saveErrors, true).length === 2 && !this.clearValidIndicator) {
            return ' shown';
        }

        return '';
    }

    render() {

        return (

            <div className="rss-section__feed-information">

                <div className="title feed-info-title">
                    <FormattedMessage id="RSS_Add_UIText_addRssFeed.feedInfo.title" />
                </div>

                <div className="name-remaining-characters-container">
                    <span className="name">
                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.feedInfo.name" />
                    </span>

                    <span className="remaining-characters">
                        <span>{this.state.characterCount}</span>
                        &nbsp;
                        <FormattedMessage id="RSS_Add_UIText_addRssFeed.feedInfo.remainingCharacters" />
                    </span>
                </div>

                <div className="input-container">
                    <input type="text"
                           autoFocus
                           maxLength={ADD_RSS_INPUT_CHAR_LIMIT}
                           className="feed-name-input"
                           onBlur={this.validateInputField}
                           onChange={this.changeFeedNameHandler}
                           value={this.state.feedNameInputValue} />
                    <img src="assets/spinner.gif"
                         className="loading-spinner-image js-input-spinner"
                         alt="Validating input" />
                    <span className={'la-Correct valid-input js-valid-name-icon' +
                                        this.setValidClass()}></span>
                    <span className={'la-Incorrect invalid-input js-invalid-name-icon' +
                                        this.props.setErrorClass([
                                            'api.error.feed.missingTitle',
                                            'api.error.feed.duplicateTitle'
                                        ])}></span>
                </div>

                <div className={'add-rss-error js-name-input-error' +
                        this.props.setErrorClass(['api.error.feed.missingTitle', 'api.error.feed.duplicateTitle'])}>
                    <FormattedMessage id="RSS_Add_Error_addRssFeed.feedInfo.unavailableNameError" />
                </div>

            </div>

        );

    }

}

export default FeedInformation;


// WEBPACK FOOTER //
// ./src/scripts/pages/RSSEditing/BaseFeedEditingComponent/template/BaseFeedEditingComponent.feedInformation.jsx